let elementProduct = document.querySelector('[data-drupal-link-system-path=product]');
let element2 = document.querySelector('[data-drupal-link-system-path=application]');
if (document.getElementById('main-menu-not-logged-in')) {
  if(element2) {
    element2.parentElement.style.display = 'none';
  }
}
if (window.location.href.split('/').includes('application')) {
  if(element2) {
    element2.classList.add('is-active');
  }
}
if (window.location.href.split('/').includes('product')) {
  if(elementProduct) {
    elementProduct.classList.add('is-active');
  }
}



